// src/redux/actions/registrationActions.js

export const SET_REGISTRATION_STEP = "SET_REGISTRATION_STEP";
export const SET_REGISTRATION_DATA = "SET_REGISTRATION_DATA";
export const CLEAR_REGISTRATION = "CLEAR_REGISTRATION";

export const setRegistrationStep = (step) => ({
  type: SET_REGISTRATION_STEP,
  payload: step,
});

export const setRegistrationData = (data) => ({
  type: SET_REGISTRATION_DATA,
  payload: data,
});

export const clearRegistration = () => ({
  type: CLEAR_REGISTRATION,
});
